import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=91e175ce&scoped=true&"
import script from "./deals.vue?vue&type=script&lang=js&"
export * from "./deals.vue?vue&type=script&lang=js&"
import style0 from "./deals.vue?vue&type=style&index=0&id=91e175ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e175ce",
  null
  
)

export default component.exports